import { IconType } from 'react-icons';
import {
  FaFileContract,
  FaRobot,
  FaBolt,
} from 'react-icons/fa';

export interface Solution {
  id: string;
  icon: IconType;
  title: string;
  tagline: string;
  description: string[];
  features: string[];
  technologies: string[];
}

export const solutions: Solution[] = [
  {
    id: 'procurement-consulting',
    icon: FaFileContract,
    title: 'AI-Powered Procurement Consulting',
    tagline: 'Automated compliance analysis for public tenders',
    description: [
      'We help public agencies and procurement professionals ensure tender fairness using AI. Our system analyzes procurement documents against Greek and EU regulations, identifying anti-competitive patterns and compliance risks in minutes instead of hours.',
      'The platform detects photographic requirements, incumbent advantage patterns, and other red flags that may limit vendor pool participation or violate procurement law.',
    ],
    features: [
      'Automated pattern detection (photographic requirements, incumbent advantage)',
      'Legal compliance checking (Law 4412/2016, EU Directive 2014/24)',
      'Actionable recommendations with legal citations',
      'Risk quantification and vendor pool impact estimates',
    ],
    technologies: ['Claude AI', 'TypeScript', 'Document Processing'],
  },
  {
    id: 'agentic-solutions',
    icon: FaRobot,
    title: 'Agentic AI Deployment',
    tagline: 'Autonomous AI systems that work for you',
    description: [
      'We build and deploy AI agents that handle complex, multi-step tasks autonomously. From document analysis to workflow automation, our agents combine reasoning with tool use to deliver expert-level results without constant human oversight.',
      'Our agents support checkpoint/resume for long-running tasks and can operate in fully autonomous or human-in-the-loop modes depending on your requirements.',
    ],
    features: [
      'Autonomous operation with human-in-the-loop options',
      'Multi-tool orchestration (read, write, search, execute)',
      'Checkpoint/resume for long-running tasks',
      'Domain-specific skill libraries',
    ],
    technologies: ['Claude Agent SDK', 'TypeScript', 'Custom Tooling'],
  },
  {
    id: 'energy-markets',
    icon: FaBolt,
    title: 'Energy Market Intelligence',
    tagline: 'Day-ahead market clearing and price forecasting',
    description: [
      'Our Euphemia-based platform models European electricity markets across 50+ bidding zones. We provide day-ahead price generation, unit commitment optimization, and transmission-aware market clearing for energy traders, utilities, and regulators.',
      'The system integrates with ENTSO-E Transparency Platform for real-time parameter inference and supports automated daily price generation.',
    ],
    features: [
      'Multi-zone market clearing with transmission constraints',
      'Unit commitment optimization (thermal, renewable)',
      'Real-time parameter inference from ENTSO-E data',
      'Automated daily price generation',
    ],
    technologies: ['Julia', 'JuMP.jl', 'PostgreSQL', 'HiGHS/Gurobi'],
  },
];
